import classNames from 'classnames';
import * as React from 'react';
import css from './BooksDeletableTextInput.module.scss';
import BooksTextInput, { TextInputType } from './BooksTextInput';

import deleteIcon from '../../../../public/static/books/delete.png';

export interface SimulatedEvent {
  currentTarget: {
    name: string;
    value: string;
  };
}

interface Props {
  disabled?: boolean;
  type?: TextInputType;
  onChange?: (e: React.ChangeEvent<HTMLInputElement> | SimulatedEvent) => void;
  value?: string;
  name: string;
}

class BooksDeletableTextInput extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  private handleClick() {
    const { disabled } = this.props;

    if (!disabled && this.props.onChange) {
      const simulatedEvent = {
        currentTarget: {
          name: this.props.name,
          // NOTE: Change the value of input to empty
          value: '',
        },
      };

      this.props.onChange(simulatedEvent);
    }
  }

  private handleChange(
    e: React.ChangeEvent<HTMLInputElement & HTMLTextAreaElement>,
  ) {
    const { disabled } = this.props;

    if (!disabled && this.props.onChange) {
      this.props.onChange(e);
    }
  }

  public render() {
    const { disabled, type } = this.props;
    const classes = classNames(css.BooksDeletableTextInput, classNames);

    return (
      <span className={classes}>
        <BooksTextInput
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
          className={css.BooksDeletableTextInput__Input}
          type={type}
        />
        <button
          className={css.BooksDeletableTextInput__Button}
          disabled={disabled}
          onClick={this.handleClick}
        >
          <img
            className={css.BooksDeletableTextInput__Icon}
            src={deleteIcon}
            alt="Delete icon"
          />
        </button>
      </span>
    );
  }
}

export default BooksDeletableTextInput;
